<button
  type="button"
  class="btn btn-secondary d-flex align-items-center gap-2"
  (click)="onQuickOpen()"
  ngbTooltip="Search for and edit device parameters. (ctrl+⇧+f or /)"
  placement="bottom-end"
  container="body"
  [openDelay]="450"
>
  <i class="bi-search"></i>
  <span class="d-none d-xxl-inline text-nowrap">PARAMETERS</span>
</button>
